<template>
    <v-card v-if="announcementMessage" class="panelBlock">
        <v-flex tag="h2"> {{announcementConstants.TITLE}} </v-flex>
        <v-flex class="announcement__info ">
            <v-flex class="inner-scrollbar" v-html="announcementMessage"> </v-flex>
        </v-flex>
    </v-card>
</template>

<script>
import { mapActions } from 'vuex';
import { storeAction } from '../../../store/storeActions.constant';
import StatusOverlay from '../../StatusOverlay/StatusOverlay';
import { replaceMemberEvent } from '../../ConnectAndChampsCommon';
import { announcementConstants } from '@/components/ChapterPage/communityCommon.constant';

export default {
    data() {
        return { 
            announcementConstants,
            announcementMessage: '',
            };
    },
    components: {
        StatusOverlay,
    },
    created() {
        this.getChapterAnnouncement().then((response) => {
            this.announcementMessage = this.replaceMemberEvent(response.data.announcement, response.data.profileList,  response.data.eventList);
        });
    },
    methods: {
        ...mapActions({
            [storeAction.getChapterAnnouncement]: `chapter/${storeAction.getChapterAnnouncement}`,
        }),
        replaceMemberEvent,
    },
    computed: {},
};
</script>

<style lang="scss" scoped>
@import '../../../common/styles/_colors.scss';
    .announcement__info {
        font-size: 14px;
        padding: 15px 10px 15px 15px;
        p {
            line-height: 20px;
        }
        .inner-scrollbar {
            max-height: 250px;
            overflow: auto;
            margin-right: 0;
        }
    }
</style>